import { Injectable } from '@angular/core';

const STORAGE_KEY = 'gestion_client_fingerprint';

@Injectable({
  providedIn: 'root',
})
export class ClientFingerprintService {
  getSync(): string {
    const STORED = localStorage.getItem(STORAGE_KEY) ?? '';
    if (STORED) {
      return STORED;
    }
    return this.persistFingerprint(this.buildRawFingerprintSync());
  }

  async get(): Promise<string> {
    const STORED = localStorage.getItem(STORAGE_KEY) ?? '';
    if (STORED) {
      return STORED;
    }

    const RAW = this.buildRawInput();
    const HASH = await this.sha256Hex(RAW);
    const FINGERPRINT = `web:${HASH}`;
    return this.persistFingerprint(FINGERPRINT);
  }

  private buildRawInput(): string {
    return [
      navigator.userAgent,
      navigator.language,
      `${screen.width}x${screen.height}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    ].join('|');
  }

  private buildRawFingerprintSync(): string {
    const RAW = this.buildRawInput();
    const HASH = this.hashHexFallback(RAW);
    return `web:${HASH}`;
  }

  private persistFingerprint(fingerprint: string): string {
    localStorage.setItem(STORAGE_KEY, fingerprint);
    return fingerprint;
  }

  private async sha256Hex(value: string): Promise<string> {
    if (!globalThis.crypto?.subtle) {
      return this.hashHexFallback(value);
    }

    try {
      const ENCODED = new TextEncoder().encode(value);
      const DIGEST = await crypto.subtle.digest('SHA-256', ENCODED);
      return Array.from(new Uint8Array(DIGEST))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
    } catch {
      return this.hashHexFallback(value);
    }
  }

  private hashHexFallback(value: string): string {
    const PARTS: string[] = [];
    let hash = 2166136261;
    for (let i = 0; i < value.length; i++) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    for (let round = 0; round < 8; round++) {
      hash = Math.imul(hash ^ (0x9e3779b9 + round), 16777619);
      PARTS.push((hash >>> 0).toString(16).padStart(8, '0'));
    }
    return PARTS.join('');
  }
}
